import {
  init_logDepthFragment
} from "./chunk-PCC7E6RX.mjs";
import {
  init_fogFragment
} from "./chunk-5PR2DJJF.mjs";
import {
  init_fogFragmentDeclaration
} from "./chunk-PTZ7MAEV.mjs";
import {
  init_logDepthDeclaration
} from "./chunk-AXOJYKSZ.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/ShadersWGSL/ShadersInclude/imageProcessingCompatibility.js
var name, shader;
var init_imageProcessingCompatibility = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/ShadersInclude/imageProcessingCompatibility.js"() {
    "use strict";
    init_shaderStore();
    name = "imageProcessingCompatibility";
    shader = `#ifdef IMAGEPROCESSINGPOSTPROCESS
fragmentOutputs.color=vec4f(pow(fragmentOutputs.color.rgb, vec3f(2.2)),fragmentOutputs.color.a);
#endif
`;
    ShaderStore.IncludesShadersStoreWGSL[name] = shader;
  }
});

// node_modules/@babylonjs/core/ShadersWGSL/sprites.fragment.js
var name2, shader2, spritesPixelShaderWGSL;
var init_sprites_fragment = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/sprites.fragment.js"() {
    init_shaderStore();
    init_fogFragmentDeclaration();
    init_logDepthDeclaration();
    init_logDepthFragment();
    init_fogFragment();
    init_imageProcessingCompatibility();
    name2 = "spritesPixelShader";
    shader2 = `uniform alphaTest: i32;varying vColor: vec4f;varying vUV: vec2f;var diffuseSamplerSampler: sampler;var diffuseSampler: texture_2d<f32>;
#include<fogFragmentDeclaration>
#include<logDepthDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
#ifdef PIXEL_PERFECT
fn uvPixelPerfect(uv: vec2f)->vec2f {var res: vec2f= vec2f(textureDimensions(diffuseSampler,0));var uvTemp=uv*res;var seam: vec2f=floor(uvTemp+0.5);uvTemp=seam+clamp((uvTemp-seam)/fwidth(uvTemp),vec2f(-0.5),vec2f(0.5));return uvTemp/res;}
#endif
@fragment
fn main(input: FragmentInputs)->FragmentOutputs {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#ifdef PIXEL_PERFECT
var uv: vec2f=uvPixelPerfect(input.vUV);
#else
var uv: vec2f=input.vUV;
#endif
var color: vec4f=textureSample(diffuseSampler,diffuseSamplerSampler,uv);var fAlphaTest: f32= f32(uniforms.alphaTest);if (fAlphaTest != 0.)
{if (color.a<0.95) {discard;}}
color*=input.vColor;
#include<logDepthFragment>
#include<fogFragment>
fragmentOutputs.color=color;
#include<imageProcessingCompatibility>
#define CUSTOM_FRAGMENT_MAIN_END
}`;
    ShaderStore.ShadersStoreWGSL[name2] = shader2;
    spritesPixelShaderWGSL = { name: name2, shader: shader2 };
  }
});

export {
  spritesPixelShaderWGSL,
  init_sprites_fragment
};
